<!-- Normal view -->
@if (!fullscreen()) {
  <div class="relative flex h-full w-full flex-col">
    @if (error) {
      <div class="flex h-full w-full flex-col items-center justify-center gap-2 p-6 text-center text-red-700">
        <mat-icon class="h-[48px]! w-[48px]! text-[48px]">broken_image</mat-icon>
        <span class="text-lg font-medium">{{ error }}</span>
      </div>
    }

    <div
      class="relative min-h-0 w-full flex-1 overflow-auto rounded-lg border border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-gray-900"
      [style]="wordActionsNormal ? 'height: calc(100% - ' + wordActionsNormal.offsetHeight + 'px)' : ''"
      (wheel)="onWheel($event)"
    >
      @if (isLoading && !error) {
        <div class="absolute inset-0 z-10 flex items-center justify-center bg-white/50 dark:bg-black/50">
          <mat-spinner diameter="48"></mat-spinner>
        </div>
      }

      <div #wordContainer class="transition-transform duration-200" [style.zoom]="zoomLevel">
        <!-- Docx-preview content goes here -->
      </div>
    </div>

    <!-- Zoom Controls -->
    <div
      #wordActionsNormal
      class="pointer-events-none absolute bottom-5 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2 rounded-3xl bg-[var(--mat-sys-surface-container-highest)]/90 px-3 py-1.5 shadow-md dark:bg-[var(--mat-sys-surface-container-lowest)]"
    >
      <button
        mat-icon-button
        class="pointer-events-auto h-8! w-8! transition-colors duration-200 disabled:opacity-40"
        (click)="zoomOut()"
        [disabled]="zoomLevel <= 0.5"
      >
        <mat-icon class="text-[20px]">zoom_out</mat-icon>
      </button>
      <span class="min-w-[40px] text-center text-xs font-medium">{{ zoomLevel * 100 | number: '1.0-0' }}%</span>
      <button
        mat-icon-button
        class="pointer-events-auto h-8! w-8! transition-colors duration-200 disabled:opacity-40"
        (click)="zoomIn()"
        [disabled]="zoomLevel >= 3"
      >
        <mat-icon class="text-[20px]">zoom_in</mat-icon>
      </button>
      <div class="mx-1 h-4 w-px bg-gray-300 dark:bg-gray-600"></div>
      <button
        mat-icon-button
        class="pointer-events-auto h-8! w-8! transition-colors duration-200"
        (click)="resetZoom()"
      >
        <mat-icon class="text-[20px]">refresh</mat-icon>
      </button>
    </div>
  </div>
}

<!-- Fullscreen Overlay -->
@if (fullscreen()) {
  <div class="fixed inset-0 z-[9999] flex items-center justify-center" (click)="fullscreen.set(false)">
    <!-- Backdrop con blur -->
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

    <!-- Popup container con sfondo di sistema -->
    <div
      class="surface relative z-10 flex h-[85vh] w-[90vw] flex-col overflow-hidden rounded-xl shadow-2xl"
      (click)="$event.stopPropagation()"
    >
      <!-- Header con bottone close -->
      <div class="flex items-center justify-end gap-2 p-2">
        <ng-container *ngTemplateOutlet="actionsTemplate() || null"></ng-container>
      </div>

      <!-- Word Content Area -->
      <div class="relative flex-1 overflow-hidden p-4">
        @if (error) {
          <div class="flex h-full w-full flex-col items-center justify-center gap-2 p-6 text-center text-red-700">
            <mat-icon class="h-[48px]! w-[48px]! text-[48px]">broken_image</mat-icon>
            <span class="text-lg font-medium">{{ error }}</span>
          </div>
        }

        <div
          class="h-full w-full overflow-auto"
          [style]="wordActionsFullscreen ? 'height: calc(100% - ' + wordActionsFullscreen.offsetHeight + 'px)' : ''"
          (wheel)="onWheel($event)"
        >
          @if (isLoading && !error) {
            <div class="absolute inset-0 z-10 flex items-center justify-center bg-white/50 dark:bg-black/50">
              <mat-spinner diameter="48"></mat-spinner>
            </div>
          }

          <div #wordContainer class="transition-transform duration-200" [style.zoom]="zoomLevel">
            <!-- Docx-preview content goes here -->
          </div>
        </div>

        <!-- Zoom Controls -->
        <div
          #wordActionsFullscreen
          class="pointer-events-none absolute bottom-5 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2 rounded-3xl bg-[var(--mat-sys-surface-container-highest)]/90 px-3 py-1.5 shadow-md dark:bg-[var(--mat-sys-surface-container-lowest)]"
        >
          <button
            mat-icon-button
            class="pointer-events-auto h-8! w-8! transition-colors duration-200 disabled:opacity-40"
            (click)="zoomOut()"
            [disabled]="zoomLevel <= 0.5"
          >
            <mat-icon class="text-[20px]">zoom_out</mat-icon>
          </button>
          <span class="min-w-[40px] text-center text-xs font-medium">{{ zoomLevel * 100 | number: '1.0-0' }}%</span>
          <button
            mat-icon-button
            class="pointer-events-auto h-8! w-8! transition-colors duration-200 disabled:opacity-40"
            (click)="zoomIn()"
            [disabled]="zoomLevel >= 3"
          >
            <mat-icon class="text-[20px]">zoom_in</mat-icon>
          </button>
          <div class="mx-1 h-4 w-px bg-gray-300 dark:bg-gray-600"></div>
          <button
            mat-icon-button
            class="pointer-events-auto h-8! w-8! transition-colors duration-200"
            (click)="resetZoom()"
          >
            <mat-icon class="text-[20px]">refresh</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
}
